// extracted by mini-css-extract-plugin
export var numpadContainer = "_pf-1";
export var phoneButton = "_pf-0";